__turbopack_context__.v({
  "aiCopy": "Qe0_QG_aiCopy",
  "aiCopyLabel": "Qe0_QG_aiCopyLabel",
  "aiSwitch": "Qe0_QG_aiSwitch",
  "aiSwitchContainer": "Qe0_QG_aiSwitchContainer",
  "aiThumb": "Qe0_QG_aiThumb",
  "aiTrack": "Qe0_QG_aiTrack",
  "switch": "Qe0_QG_switch",
  "thumb": "Qe0_QG_thumb",
  "track": "Qe0_QG_track",
});
